import type { SummaryStats } from '@/utils/analytics'

interface SummaryCardsProps {
  stats: SummaryStats
}

// NHMRC low-risk weekly std-drink ceiling
const NHMRC_WEEKLY_LIMIT = 10

function fmtNum(n: number, decimals = 0): string {
  return n.toLocaleString(undefined, { maximumFractionDigits: decimals, minimumFractionDigits: decimals })
}

export default function SummaryCards({ stats }: SummaryCardsProps) {
  const overGuideline = stats.avgStdDrinksPerWeek > NHMRC_WEEKLY_LIMIT
  const guidelineRatio = stats.avgStdDrinksPerWeek / NHMRC_WEEKLY_LIMIT

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <div className="card">
        <p className="text-xs uppercase tracking-wide text-[var(--text-secondary)]">Total drinks</p>
        <p className="text-2xl font-bold text-[var(--text-primary)] mt-1">{fmtNum(stats.totalDrinks)}</p>
        <p className="text-xs text-[var(--text-secondary)] mt-1">
          {fmtNum(stats.avgDrinksDrinkingDays, 1)} avg / drinking day
        </p>
      </div>

      <div className="card">
        <p className="text-xs uppercase tracking-wide text-[var(--text-secondary)]">Sober days</p>
        <p className="text-2xl font-bold text-[var(--accent-teal)] mt-1">{fmtNum(stats.soberDayPercent, 0)}%</p>
        <p className="text-xs text-[var(--text-secondary)] mt-1">
          {fmtNum(stats.soberDays)} of {fmtNum(stats.soberDays + stats.drinkingDays)} days
        </p>
      </div>

      <div className="card">
        <p className="text-xs uppercase tracking-wide text-[var(--text-secondary)]">Avg peak BAC</p>
        <p className="text-2xl font-bold text-[var(--text-primary)] mt-1 font-mono">
          {stats.avgPeakBacDrinkingDays.toFixed(3)}%
        </p>
        <p className="text-xs text-[var(--text-secondary)] mt-1">
          max {stats.maxPeakBac.toFixed(3)}%
        </p>
      </div>

      <div className="card">
        <p className="text-xs uppercase tracking-wide text-[var(--text-secondary)]">Std drinks / wk</p>
        <p
          className={
            'text-2xl font-bold mt-1 ' +
            (overGuideline ? 'text-[var(--bac-danger)]' : 'text-[var(--text-primary)]')
          }
        >
          {fmtNum(stats.avgStdDrinksPerWeek, 1)}
        </p>
        <p className="text-xs text-[var(--text-secondary)] mt-1">
          NHMRC limit {NHMRC_WEEKLY_LIMIT}
          {overGuideline && ` (${fmtNum(guidelineRatio, 1)}×)`}
        </p>
      </div>
    </div>
  )
}
